import { render } from "./MyPagination.vue?vue&type=template&id=0d7b5526&scoped=true&ts=true"
import script from "./MyPagination.vue?vue&type=script&lang=ts"
export * from "./MyPagination.vue?vue&type=script&lang=ts"

import "./MyPagination.vue?vue&type=style&index=0&id=0d7b5526&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7b5526"]])

export default __exports__